<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Box from "../component/boxperfil";

export default {
    components: { Layout, PageHeader, Swal, Box },
    data() {
        return {
            title: "Configuración",
            items: [
                {
                    text: "Inicio",
                    href: "/"
                },
                {
                    text: "Configuración",
                    active: true
                }
            ],
            //Datos categorias
            categorias: {},
            categoria: null,
            isLoading1: false,
            categoriaEditandoId: null,
            datos1: {
                name: ''
            },
            //Datos marca
            marcas: {},
            marca: null,
            isLoading2: false,
            datos2: {
                name: ''
            },
            //Datos medidas
            medidas: {},
            medida: null,
            isLoading3: false,
            datos3: {
                name: '',
                codigo: '',
            },
            //Clasificaciones
            tipos: [{ 'id': 1 }],
            tipo: null,
            isLoading4: false,
            datos4: {
                name: '',
                codigo: '',
            },
            //Ubicaciones
            ubicaciones: {},
            ubicacion: null,
            isLoading5: false,
            datos5: {
                name: ''
            },
            //Clientes
            clientes: {},
            cliente: null,
            isLoading6: false,
            datos6: {
                name: ''
            },
            //productos
            productos: [],
            producto: null,
            ingredientes: [],
            datos7: {
                tipo_id: "",
                name: "",
                venta: 0,
                ventax2: 0,
                disponible: 1,
                doble: 0,
                ingredientes: [1],
                ingredientesx2: [],
                ingredientesCantidades: {},
            },
            valor_editar: {
                tipo_id: "",
                name: "",
                venta: 0,
                ventax2: 0,
                disponible: 1,
                doble: 0,
                ingredientes: [1],
                ingredientesCantidades: {},
            },
            isLoading7: false,
            //ingredientes
            articulos: [],
            articulos_mes: [],
            articulo: {
                name: "",
                barra: "",
                sku: "",
                marca_id: '',
                medida_id: '',
                categoria_id: '',
                tipo_id:'',
                ubicacion_id: '',
                def: '',
                stock_minimo: 5
            },
            isLoading8: false,
            producto_nuevo: false,
            buttonDisabled: true,
            fileproductos: [],
            //Canales
            canales: {},
            canal: null,
            isLoading9: false,
            datos9: {
                name: '',
            },
            //Turnos
            turnos: {},
            turno: null,
            isLoading10: false,
            datos10: {
                name: '',
                alias: '',
                horario_inicio: null,
                horario_termino: null,
            },
            horariosi: [
                { "value": "00:00", "text": "00:00 AM" },
                { "value": "01:00", "text": "01:00 AM" },
                { "value": "02:00", "text": "02:00 AM" },
                { "value": "03:00", "text": "03:00 AM" },
                { "value": "04:00", "text": "04:00 AM" },
                { "value": "05:00", "text": "05:00 AM" },
                { "value": "06:00", "text": "06:00 AM" },
                { "value": "07:00", "text": "07:00 AM" },
                { "value": "08:00", "text": "08:00 AM" },
                { "value": "09:00", "text": "09:00 AM" },
                { "value": "10:00", "text": "10:00 AM" },
                { "value": "11:00", "text": "11:00 AM" },
                { "value": "12:00", "text": "12:00 PM" },
                { "value": "13:00", "text": "01:00 PM" },
                { "value": "14:00", "text": "02:00 PM" },
                { "value": "15:00", "text": "03:00 PM" },
                { "value": "16:00", "text": "04:00 PM" },
                { "value": "17:00", "text": "05:00 PM" },
                { "value": "18:00", "text": "06:00 PM" },
                { "value": "19:00", "text": "07:00 PM" },
                { "value": "20:00", "text": "08:00 PM" },
                { "value": "21:00", "text": "09:00 PM" },
                { "value": "22:00", "text": "10:00 PM" },
                { "value": "23:00", "text": "11:00 PM" }
            ], horariosf: [
                { "value": "00:59", "text": "00:59 AM" },
                { "value": "01:59", "text": "01:59 AM" },
                { "value": "02:59", "text": "02:59 AM" },
                { "value": "03:59", "text": "03:59 AM" },
                { "value": "04:59", "text": "04:59 AM" },
                { "value": "05:59", "text": "05:59 AM" },
                { "value": "06:59", "text": "06:59 AM" },
                { "value": "07:59", "text": "07:59 AM" },
                { "value": "08:59", "text": "08:59 AM" },
                { "value": "09:59", "text": "09:59 AM" },
                { "value": "10:59", "text": "10:59 AM" },
                { "value": "11:59", "text": "11:59 AM" },
                { "value": "12:59", "text": "12:59 PM" },
                { "value": "13:59", "text": "01:59 PM" },
                { "value": "14:59", "text": "02:59 PM" },
                { "value": "15:59", "text": "03:59 PM" },
                { "value": "16:59", "text": "04:59 PM" },
                { "value": "17:59", "text": "05:59 PM" },
                { "value": "18:59", "text": "06:59 PM" },
                { "value": "19:59", "text": "07:59 PM" },
                { "value": "20:59", "text": "08:59 PM" },
                { "value": "21:59", "text": "09:59 PM" },
                { "value": "22:59", "text": "10:59 PM" },
                { "value": "23:59", "text": "11:59 PM" }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 100,
            pageOptions: [100],
            filter: null,
            filterOn: [],
            sortBy: "nombre",
            sortDesc: false,
            fields: [
                { key: "index", label: "#", sortable: true },
                { key: "nombre", label: "NOMBRE", sortable: true },
            ]
        };
    },
    computed: {
        rows() {
            return this.articulos.length;
        },
        categoriasDetectadasProductos() {
            const clasificaciones = Array.isArray(this.tipos)
                ? this.tipos
                    .map(t => (t?.name || '').trim())
                    .filter(name => name !== '')
                : [];

            return [...new Set(clasificaciones)].sort((a, b) => a.localeCompare(b));
        },
        categoriasFaltantesDesdeProductos() {
            const existentes = (Array.isArray(this.categorias) ? this.categorias : [])
                .map(c => (c?.name || '').trim().toLowerCase());

            return this.categoriasDetectadasProductos.filter(def => !existentes.includes(def.toLowerCase()));
        }
    },
    watch: {
        // Opcional: Cuando se deselecciona un ingrediente, se puede limpiar su cantidad
        "datos7.ingredientes"(nuevosIngredientes, antiguosIngredientes) {
        antiguosIngredientes.forEach(ingredienteId => {
            if (!nuevosIngredientes.includes(ingredienteId)) {
            // Se elimina la clave asociada al ingrediente deseleccionado
            this.$delete(this.datos7.ingredientesCantidades, ingredienteId);
            }
        });
        }
    },
    methods: {
        get_data() {
            this.isLoading = true
            try {
                axios.get('/api/inventarios').then(res => {
                    this.categorias = res.data.categorias;
                    this.marcas = res.data.marcas;
                    this.medidas = res.data.medidas;
                    this.tipos = res.data.tipos;
                    this.ubicaciones = res.data.ubicaciones;
                    this.clientes = res.data.clientes;
                    this.productos = res.data.productos;
                    this.productos.forEach(element => {
                        element.ingredientes_base = JSON.parse(element.ingredientes);
                        element.ingredientes = JSON.parse(element.ingredientes);
                        element.ingredientesx2 = JSON.parse(element.ingredientesx2);
                        element.ing_adicionales = [];
                    });
                    this.ingredientes = res.data.ingredientes;
                    this.canales = res.data.canales;
                    this.turnos = res.data.turnos;
                    
                    this.articulos = res.data.datos;
                    this.articulos_mes = res.data.datos_mes;
                    this.sincronizarCategoriasDesdeProductos(true);
                    //console.log(this.articulos_mes)
                    this.isLoading = false
                    this.$toasted.success('Datos cargados!');
                })
                axios.get('/api/categorias').then(res => {
                    if (res.data?.estado && Array.isArray(res.data.datos)) {
                        this.categorias = res.data.datos;
                        this.sincronizarCategoriasDesdeProductos(true);
                    }
                })
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false
            }
            this.datos7={
                tipo_id: '',
                name: "",
                venta: '',
                ventax2: 0,
                disponible: 1,
                doble: 0,
                ingredientes: [],
                ingredientesx2: [],
                ingredientesCantidades: {},
                
            },
            this.user.sucursal.categorizaciones.includes('CODIGODEBARRA') ? this.fields.push({ key: "cod", label: "CÓDIGO DE BARRA", sortable: true }) : '';
            this.user.sucursal.categorizaciones.includes('Marcas') ? this.fields.push({ key: "marca", label: "MARCA", sortable: true }) : '';
            this.user.sucursal.categorizaciones.includes('Categorias') ? this.fields.push({ key: "categoria", label: "CATEGORIA", sortable: true }) : '';
            this.user.sucursal.categorizaciones.includes('Ubicaciones') ? this.fields.push({ key: "ubicacion", label: "UBICACIÓN", sortable: true }) : '';
            this.fields.push({ key: "stock_mes_anterior", label: "VENTAS/MES_PASADO", sortable: false })
            this.fields.push({ key: "stock_mes", label: "VENTAS/MES", sortable: false })
            // this.fields.push({ key: "acciones", label: "ACCIONES", sortable: false })
        },
        agregar1() {
            const nombre = (this.datos1.name || '').trim();
            if (!nombre) {
                this.$toasted.error('Debes ingresar un nombre de categoría');
                return;
            }

            const duplicada = (Array.isArray(this.categorias) ? this.categorias : [])
                .some(c => (c?.name || '').trim().toLowerCase() === nombre.toLowerCase()
                    && String(c?.id) !== String(this.categoriaEditandoId || ''));

            if (duplicada) {
                this.$toasted.error('Ya existe una categoría con ese nombre');
                return;
            }

            this.isLoading1 = true
            const payload = {
                name: nombre,
                categoriaP_id: ''
            };

            const enEdicion = !!this.categoriaEditandoId;
            const request = enEdicion
                ? axios.put('/api/categorias/' + this.categoriaEditandoId, payload)
                : axios.post('/api/categorias', payload);

            request.then(res => {
                if (res.data.estado || this.categoriaEditandoId) {
                    this.categoria = res.data.categoria || null;
                    this.cancelarEdicionCategoria();
                    this.get_data();
                    this.$toasted.success(enEdicion ? 'Categoría actualizada' : 'Categoría creada');
                } else {
                    alert('error al guardar categoría')
                }
                this.isLoading1 = false
            }).catch(() => {
                this.isLoading1 = false
                this.$toasted.error('No se pudo guardar la categoría');
            })
        },
        eliminar1(id) {
            this.isLoading1 = true
            axios.delete('/api/categorias/' + id).then(res => {
                this.get_data()
                this.isLoading1 = false
            })
        },
        editar1(categoria) {
            this.categoriaEditandoId = categoria.id;
            this.datos1.name = categoria.name || '';
        },
        cancelarEdicionCategoria() {
            this.categoriaEditandoId = null;
            this.datos1.name = '';
        },
        async sincronizarCategoriasDesdeProductos(silencioso = false) {
            const faltantes = this.categoriasFaltantesDesdeProductos;
            if (!faltantes.length) {
                if (!silencioso) {
                    this.$toasted.info('No hay categorías pendientes desde productos');
                }
                return;
            }

            this.isLoading1 = true;
            try {
                for (const nombre of faltantes) {
                    await axios.post('/api/categorias', {
                        name: nombre,
                        categoriaP_id: ''
                    });
                }
                await this.get_data();
                if (!silencioso) {
                    this.$toasted.success('Categorías de productos sincronizadas');
                }
            } catch (e) {
                console.log(e);
                if (!silencioso) {
                    this.$toasted.error('No se pudieron sincronizar todas las categorías');
                }
            } finally {
                this.isLoading1 = false;
            }
        },
        agregar2() {
            this.isLoading2 = true
            axios.post('/api/marcas', this.datos2).then(res => {
                if (res.data.estado) {
                    this.marca = res.data.marca;
                    this.datos2.name = ''
                    this.get_data()
                } else {
                    alert('error al agregar')
                }
                this.isLoading2 = false
            })
        },
        eliminar2(id) {
            this.isLoading2 = true
            axios.delete('/api/marcas/' + id).then(res => {
                this.marcas = res.data.datos2;
                this.get_data()
                this.isLoading2 = false
            })
        },
        agregar3() {
            this.isLoading3 = true
            axios.post('/api/medidas', this.datos3).then(res => {
                if (res.data.estado) {
                    this.medida = res.data.medida;
                    this.datos3.name = ''
                    this.datos3.codigo = ''
                    this.get_data()
                } else {
                    Swal.fire({
                        //position: "top-end",
                        icon: "warning",
                        title: "Error al agregar",
                        text: '',
                        showConfirmButton: true,
                        timer: 5000
                    });
                }
                this.isLoading3 = false
            })
        },
        eliminar3(id) {
            this.isLoading3 = true
            axios.delete('/api/medidas/' + id).then(res => {
                this.medidas = res.data.datos;
                this.get_data()
                this.isLoading3 = false
            })
        },
        agregar4() {
            this.isLoading4 = true
            axios.post('/api/tipos', this.datos4).then(res => {
                if (res.data.estado) {
                    this.tipo = res.data.tipo;
                    this.datos4.name = ''
                    this.datos4.codigo = ''
                    this.get_data()
                } else {
                    alert('error al agregar')
                }
                this.isLoading4 = false
            })
        },
        eliminar4(id) {
            this.isLoading4 = true
            axios.delete('/api/tipos/' + id).then(res => {
                this.tipos = res.data.datos;
                this.get_data()
                this.isLoading4 = false
            })
        },
        agregar5() {
            this.isLoading5 = true
            axios.post('/api/ubicaciones', this.datos5).then(res => {
                if (res.data.estado) {
                    this.ubicacion = res.data.ubicacion;
                    this.datos5.name = ''
                    this.get_data()
                } else {
                    alert('error al agregar')
                }
                this.isLoading5 = false
            })
        },
        eliminar5(id) {
            this.isLoading5 = true
            axios.delete('/api/ubicaciones/' + id).then(res => {
                this.ubicaciones = res.data.datos;
                this.get_data()
                this.isLoading5 = false
            })
        },
        agregar6() {
            this.isLoading6 = true
            axios.post('/api/clientes', this.datos6).then(res => {
                if (res.data.estado) {
                    this.cliente = res.data.cliente;
                    this.datos6.name = ''
                    this.datos6.descripcion = ''
                    this.get_data()
                } else {
                    alert('error al agregar')
                }
                this.isLoading6 = false
            })
        },
        eliminar6(id) {
            this.isLoading6 = true
            axios.delete('/api/clientes/' + id).then(res => {
                this.clientes = res.data.datos;
                this.get_data()
                this.isLoading6 = false
            })
        },
        //Metodos Productos
        agregar7() {
            this.isLoading7 = true
            try {
                if(true){// siempre es producto
                    axios.post('/api/productos', this.datos7).then(res => {
                        if (res.data.estado) {
                            this.producto = res.data.producto;
                            this.datos7.name = ''
                            this.get_data()
                        } else {
                            alert('error al agregar')
                        }
                        this.isLoading7 = false
                    })
                }else{
                    this.isLoading8 = true
                    this.articulo.name=this.datos7.name
                    this.articulo.venta=this.datos7.venta
                    this.articulo.tipo_id=this.datos7.tipo_id
                    this.articulo.disponible=this.datos7.disponible
                    this.articulo.local=this.datos7.local
                    // this.articulo.pedidosYa=this.datos7.pedidosYa

                    axios.post('/api/articulos', this.articulo).then(res => {
                        if (res.data.estado) {
                            this.articulo = res.data.articulo
                            this.get_data()
                        } else {
                            Swal.fire({
                                //position: "top-end",
                                icon: "warning",
                                title: "Error al agregar",
                                text: '',
                                showConfirmButton: true,
                                timer: 5000
                            });
                        }
                        this.isLoading8 = false
                    })
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading7 = false
            }
            this.datos7.ingredientesx2 = []
        },
        editar_valor_producto7(producto) {
            this.valor_editar = { ...producto }
            if (!this.valor_editar.tipo_id && this.valor_editar.def) {
                const tipoPorNombre = this.tipos.find(t => t.name == this.valor_editar.def)
                this.valor_editar.tipo_id = tipoPorNombre ? tipoPorNombre.id : ''
            }
            this.valor_editar.disponible=this.valor_editar.disponible=='1'?true:false;
            this.valor_editar.local=this.valor_editar.local=='1'?true:false;
            // this.valor_editar.pedidosYa=this.valor_editar.pedidosYa=='1'?true:false;
            // this.valor_editar.WhatsApp=this.valor_editar.WhatsApp=='1'?true:false;
            // this.valor_editar.UberEats=this.valor_editar.UberEats=='1'?true:false;
            console.log(this.valor_editar)
            this.$refs['editar_valor_producto'].show();
        },
        eliminar7(id) {
            this.isLoading7 = true
            axios.delete('/api/productos/' + id).then(res => {
                this.productos = res.data.datos;
                this.get_data()
                this.isLoading7 = false
            })
        },
        guardar_valor7() {
            if (this.valor_editar.name != "") {
                this.isLoading7 = true
                axios.put('/api/productos/' + this.valor_editar.id, this.valor_editar).then(res => {
                    if (res.data.estado) {
                        this.producto = res.data.producto
                        this.get_data()
                        this.isLoading7 = false
                        this.$refs['editar_valor_producto'].hide();
                        this.valor_editar = {}
                    } else {
                        Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "Error al agregar",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    this.isLoading7 = false
                })
            } else {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "Nombre invalido",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                }).then((result) => {
                    this.$refs['modal_producto'].show();
                })
            }
        },
        
        //Metodos Ingredientes
        eliminar8(item) {
            Swal.fire({
                title: '¿Estás seguro/a de eliminar ' + item.name + '?',
                text: "Este cambio no puede ser revertido",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirmar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.isLoading8 = true
                    axios.delete('/api/articulos/' + item.id).then(res => {
                        this.articulos = res.data.datos;
                        this.get_data()
                        this.isLoading8 = false
                    })
                }
            })
        },
        nuevo_producto() {
            this.isLoading8 = true
            axios.post('/api/articulos', this.articulo).then(res => {
                if (res.data.estado) {
                    this.articulo = res.data.articulo
                    this.get_data()
                } else {
                    alert('error al agregar')
                }
                this.isLoading8 = false
            })
        },
        ver_modal_producto(tipo, articulo) {
            if (tipo == 'nuevo') {
                this.producto_nuevo = true;
                this.articulo.name = "";
                this.articulo.barra = "";
                this.articulo.sku = "";
                this.articulo.marca_id = '';
                this.articulo.medida_id = '';
                this.articulo.categoria_id = '';
                this.articulo.tipo_id = '';
                this.articulo.ubicacion_id = '';
                this.articulo.stock_minimo = 5;
                this.articulo.local = 0;
                // this.articulo.pedidosYa = 0;
            } else {
                this.producto_nuevo = false;
                this.articulo = articulo
                this.articulo.stock_minimo = parseInt(articulo.stock_minimo)
            }
            this.$refs['modal_producto'].show();
        },
        update_producto() {
            this.isLoading8 = true
            axios.put('/api/articulos/' + this.articulo.id, this.articulo).then(res => {
                if (res.data.estado) {
                    this.articulo = res.data.articulo
                    this.get_data()
                } else {
                    Swal.fire({
                        //position: "top-end",
                        icon: "warning",
                        title: "Error al agregar",
                        text: '',
                        showConfirmButton: true,
                        timer: 5000
                    });
                }
                this.isLoading8 = false
            })
        },
        guardar_producto() {
            this.isLoading8 = true
            axios.post('/api/articulos', this.articulo).then(res => {
                if (res.data.estado) {
                    this.articulo = res.data.articulo
                    this.get_data()
                } else {
                    Swal.fire({
                        //position: "top-end",
                        icon: "warning",
                        title: "Error al agregar",
                        text: '',
                        showConfirmButton: true,
                        timer: 5000
                    });
                }
                this.isLoading8 = false
            })
        },
        onFileProductosChange(e) {
            this.fileproductos = e.target.files[0];
            this.buttonDisabled = false;
        },
        descargar_formato() {
            let url = '/csv/formato_productos.csv';
            // Abrir una nueva ventana con la URL del archivo
            window.open(url, '_blank');
        },
        uploadCsvArticulos() {
            this.isLoading8 = true;
            if (this.buttonDisabled) {
                return; // Si está deshabilitado, salir sin hacer nada
            }
            this.buttonDisabled = true;

            let formData = new FormData();
            formData.append('file', this.fileproductos);

            axios.post('/api/upload_csv_articulos', formData).then(res => {
                if (res.data.estado) {
                    this.$refs['csv'].hide();
                    console.log(res.data.mensaje);
                    console.log(res.data.productosCargados);
                    console.log(res.data.productosError);
                    this.get_data()
                    this.isLoading8 = false;
                }
            }).catch(error => {
                console.error(error);
                this.isLoading9 = false;
            });

            setTimeout(() => {
                // Volver a habilitar el botón después de algún tiempo (por ejemplo, 3 segundos)
                this.buttonDisabled = false;
            }, 5000);
        },
        bloquearNoNumeros(e) {
            const charCode = e.charCode || e.keyCode;
            // Permitir solo dígitos del 0 al 9
            if (charCode < 48 || charCode > 57) {
                e.preventDefault();
            }
        },

        //Metodos Canales
        agregar9() {
            this.isLoading9 = true
            axios.post('/api/canals', this.datos9).then(res => {
                if (res.data.estado) {
                    this.canal = res.data.canal;
                    this.datos9.name = ''
                    this.get_data()
                } else {
                    alert('error al agregar')
                }
                this.isLoading9 = false
            })
        },
        eliminar9(id) {
            this.isLoading9 = true
            axios.delete('/api/canals/' + id).then(res => {
                this.canales = res.data.datos;
                this.get_data()
                this.isLoading9 = false
            })
        },
        agregar10() {
            this.isLoading10 = true
            axios.post('/api/turnos', this.datos10).then(res => {
                if (res.data.estado) {
                    this.turno = res.data.turno;
                    this.datos10.name = ''
                    this.datos10.alias = ''
                    this.get_data()
                } else {
                    alert('error al agregar')
                }
                this.isLoading10 = false
            })
        },
        eliminar10(id) {
            this.isLoading10 = true
            axios.delete('/api/turnos/' + id).then(res => {
                this.turnos = res.data.datos;
                this.get_data()
                this.isLoading10 = false
            })
        },
        editar_turno(turno) {
            this.turno_editar = turno
            this.$refs['editar_turno'].show();
        },
        guardar_turno() {
            if (this.turno_editar.name != "") {
                this.isLoading10 = true
                axios.put('/api/turnos/' + this.turno_editar.id, this.turno_editar).then(res => {
                    if (res.data.estado) {
                        this.turno = res.data.turno
                        this.get_data()
                        this.isLoading10 = false
                        this.$refs['editar_turno'].hide();
                        this.turno_editar = {}
                    } else {
                        Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "Error al agregar",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    this.isLoading10 = false
                })
            } else {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "Nombre invalido",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                }).then((result) => {
                    this.$refs['editar_turno'].show();
                })
            }
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        }
    },
    mounted() {
        this.get_data();
        this.totalRows = this.items.length;
        this.$toasted.success('Datos cargados!');
    },
}
</script>
<style scoped>
.card-highlight {
    border: 1px solid #ccc;
    /* Borde gris suave */
    border-radius: 5px;
    /* Bordes redondeados */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    /* Sombra gris suave */
}
</style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <Box />
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-tabs content-class="mt-3" pills card align="center">
                            <b-tab title="Productos" active>
                                <div class="row">
                                    <b-modal id="editar_valor_producto" ref="editar_valor_producto" hide-footer centered header-bg-variant="primary">
                                        <template #modal-header="{ close }">
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <!-- Título del modal -->
                                                <h5 class="text-white m-0">Editar {{ valor_editar.name }}</h5>
                                                <!-- Botón de cierre -->
                                                <b-button class="text-white p-0" size="sm" variant="none" @click="close()">
                                                <i class="bx bx-x font-size-16"></i>
                                                </b-button>
                                            </div>
                                        </template>
                                        <div class="row justify-content-center">
                                            <div class="col-md-12">
                                                <div class="card overflow-hidden card-highlight">
                                                    <div class="card-body">
                                                        <b-form-group id="input-group-1" label="Clasificación:" label-for="input-1">
                                                            <select class="custom-select" v-model="valor_editar.tipo_id">
                                                                <option value="" disabled>Selecciona la Clasificacion</option>
                                                                <option v-for="(tipo, i) in (tipos.filter(t => t.es_producto).length ? tipos.filter(t => t.es_producto) : tipos)" :label="tipo.name"
                                                                    :value="tipo.id" :key="i">
                                                                </option>
                                                            </select>
                                                        </b-form-group>
                                                        <b-form-group label-cols-sm="12" label-cols-lg="12" label="Nombre:">
                                                            <b-form-input for="text" placeholder="Nombre Producto"
                                                                v-model="valor_editar.name"></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group id="input-group-122" label="Valor"
                                                            label-for="input-122">
                                                            <b-form-input id="input-122" v-model="valor_editar.venta"
                                                                type="text"></b-form-input>
                                                        </b-form-group>
                                                        <b-form-group>
                                                            <b-form-checkbox id="valor_editar_dip"
                                                                name="valor_editar_dip" v-model="valor_editar.disponible">
                                                                Disponible
                                                            </b-form-checkbox>
                                                        </b-form-group>
                                                        <div class="row">
                                                            <div class="col-md-4">
                                                                <p>Lugar:</p>
                                                                <b-form-checkbox v-model="valor_editar.local" :true-value="1"
                                                                    :false-value="0" class="me-3">
                                                                    Local
                                                                </b-form-checkbox>
                                                                <!-- <b-form-checkbox v-model="valor_editar.pedidosYa" :true-value="1"
                                                                    :false-value="0">
                                                                    PedidosYa
                                                                </b-form-checkbox>
                                                                <b-form-checkbox v-model="valor_editar.WhatsApp" :true-value="1"
                                                                    :false-value="0">
                                                                    WhatsApp
                                                                </b-form-checkbox>
                                                                <b-form-checkbox v-model="valor_editar.UberEats" :true-value="1"
                                                                    :false-value="0">
                                                                    UberEats
                                                                </b-form-checkbox> -->
                                                            </div>

                                                            <div class="col-md-6">
                                                                <p>Ingredientes:</p>
                                                                <div v-for="ingrediente in ingredientes"
                                                                    :key="ingrediente.id"
                                                                    class="d-flex align-items-center"
                                                                >
                                                                    <div v-if="valor_editar.articulos?.find(articulo=>articulo.id==ingrediente.id)?.pivot.porcion">
                                                                        <!-- Nombre del ingrediente -->
                                                                        <label
                                                                        :for="'ingredient-' + ingrediente.id"
                                                                        class="mb-0"
                                                                        style="min-width: 150px;"
                                                                        >
                                                                        {{ ingrediente.name }} {{valor_editar.articulos?.find(articulo=>articulo.id==ingrediente.id)?.pivot.porcion}} 
                                                                        <span class="small text-muted">
                                                                            ({{ medidas.find(m => m.id === ingrediente.medida_id)?.name || '' }})
                                                                        </span>
                                                                        </label>

                                                                        <!-- Input para la cantidad -->
                                                                        <div class="ms-auto" style="width: 200px;">
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-4">
                                                            <button class="btn btn-primary btn-sm py-2 px-4"
                                                                @click="guardar_valor7">
                                                                Guardar
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </b-modal>
                                    <div class="col-md-12">
                                        <div class="bg-soft-primary mb-4 p-4">
                                            <label class="mb-3" for="title"><h3>Agregar producto compuesto</h3></label>
                                            <b-form-group id="input-group-1" label="Clasificación:" label-for="input-1">
                                                <select class="custom-select" v-model="datos7.tipo_id">
                                                    <option value="" disabled>Selecciona la Clasificacion</option>
                                                    <option v-for="(tipo, i) in (tipos.filter(t => t.es_producto).length ? tipos.filter(t => t.es_producto) : tipos)" :label="tipo.name"
                                                        :value="tipo.id" :key="i">
                                                    </option>
                                                </select>
                                            </b-form-group>
                                            <b-form-group label-cols-sm="12" label-cols-lg="12" label="Nombre:">
                                                <b-form-input for="text" placeholder="Nombre Producto"
                                                    v-model="datos7.name"></b-form-input>
                                            </b-form-group>
                                            <b-form-group label-cols-sm="12" label-cols-lg="12" label="Precio:">
                                                <b-form-input for="text" type="number" :min="0" placeholder="Precio"
                                                    v-model="datos7.venta"></b-form-input>
                                            </b-form-group>
                                                <div class="row">
                                                    <!-- Checkbox para "Disponible" -->
                                                    <div class="col-md-4">
                                                        <p>Opciones:</p>
                                                        <b-form-checkbox v-model="datos7.disponible" :true-value="1"
                                                            :false-value="0" class="me-3">
                                                            Disponible
                                                        </b-form-checkbox>
                                                        <!-- <div v-if="datos7.tipo_id == 1">
                                                            <b-form-checkbox v-model="datos7.doble" :true-value="1"
                                                                :false-value="0" class="me-3">
                                                                Hamburguesa Doble
                                                            </b-form-checkbox>
                                                        </div> -->
                                                    </div>
                                                    <div class="col-md-4">
                                                        <p>Lugar:</p>
                                                        <b-form-checkbox v-model="datos7.local" :true-value="1"
                                                            :false-value="0" class="me-3">
                                                            Local
                                                        </b-form-checkbox>
                                                        <!-- <b-form-checkbox v-model="datos7.pedidosYa" :true-value="1"
                                                            :false-value="0">
                                                            PedidosYa
                                                        </b-form-checkbox>
                                                        <b-form-checkbox v-model="datos7.WhatsApp" :true-value="1"
                                                            :false-value="0">
                                                            WhatsApp
                                                        </b-form-checkbox>
                                                        <b-form-checkbox v-model="datos7.UberEats" :true-value="1"
                                                            :false-value="0">
                                                            UberEats
                                                        </b-form-checkbox> -->
                                                    </div>
                                                </div>
                                                <div v-if="datos7.tipo_id != ''">
                                                    <!--
                                                <div class="row">
                                                     <div class="col-md-4">
                                                    <b-form-group label-cols-sm="12" label-cols-lg="3"  label="Precio x2" v-if="datos7.doble">
                                                        <b-form-input for="text" placeholder="Precio doble" v-model="datos7.ventax2"  ></b-form-input>
                                                    </b-form-group>
                                                </div> 
                                                </div>-->
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <b-form-group label-cols-sm="12">
                                                        <p>Ingredientes:</p>
                                                        <div
                                                            v-for="ingrediente in ingredientes.filter(i => this.datos7.tipo_id==1 ||this.datos7.tipo_id==2 ? i.def.includes('Ingredientes'):i.tipo_id==this.datos7.tipo_id)"
                                                            :key="ingrediente.id"
                                                            class="d-flex align-items-center mb-2"
                                                        >
                                                            <!-- Checkbox a la izquierda -->
                                                            <b-form-checkbox
                                                            :id="'ingredient-' + ingrediente.id"
                                                            v-model="datos7.ingredientes"
                                                            :value="ingrediente.id"
                                                            class="me-2"
                                                            ></b-form-checkbox>

                                                            <!-- Nombre del ingrediente -->
                                                            <label
                                                            :for="'ingredient-' + ingrediente.id"
                                                            class="mb-0"
                                                            style="min-width: 150px;"
                                                            >
                                                            {{ ingrediente.name }}
                                                            <span class="small text-muted">
                                                                ({{ medidas.find(m => m.id === ingrediente.medida_id)?.name || '' }})
                                                            </span>
                                                            </label>

                                                            <!-- Input para la cantidad -->
                                                            <div v-if="datos7.ingredientes.includes(ingrediente.id)" class="ms-auto" style="width: 200px;">
                                                                <b-form-input
                                                                type="text"
                                                                size="sm"
                                                                :placeholder="'Cantidad/Porción'"
                                                                v-model="datos7.ingredientesCantidades[ingrediente.id]"
                                                                @keypress="bloquearNoNumeros"
                                                                ></b-form-input>
                                                            </div>
                                                        </div>
                                                        </b-form-group>
                                                    </div>
                                                    </div>
                                                 </div>
                                            <!-- <div class="row">
                                                <div class="col-md-4" v-if="datos7.doble">
                                                    <b-form-group label-cols-sm="12" label="X2">
                                                        <div v-for="ingrediente in ingredientes.filter(ingrediente => ingrediente.def.includes('Ingredientesx2'))"
                                                            :key="ingrediente.id" class="form-check">
                                                            <input class="form-check-input" type="checkbox"
                                                                :id="'ingredient' + ingrediente.id"
                                                                :value="ingrediente.id" v-model="datos.ingredientesx2">
                                                            <label class="form-check-label"
                                                                :for="'ingredient' + ingrediente.id">
                                                                {{ ingrediente.name }}
                                                            </label>
                                                        </div>
                                                    </b-form-group>
                                                </div>
                                            </div> -->
                                            <b-button block variant="primary" class="mt-3" @click="agregar7()" :disabled="datos7.name == '' || datos7.venta == '' || datos7.venta < 0 || this.productos.some(producto => producto.name == datos7.name)">
                                                Agregar Producto
                                            </b-button>
                                            <span 
                                                v-if="this.productos.some(producto => producto.name == datos7.name)" 
                                                class="text-danger">
                                                ¡Ya existe un producto con ese nombre!
                                            </span>
                                            <loading-message v-if="isLoading7" />
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="table-responsive">
                                            <table class="table table-hover mb-0">
                                                <thead>
                                                    <th class="py-0 px-1">#</th>
                                                    <th class="py-0 px-1">NOMBRE</th>
                                                    <th class="py-0 px-1">VALOR</th>
                                                    <!-- <th class="py-0 px-1">X2</th> -->
                                                    <th class="py-0 px-1">DISPONIBLE</th>
                                                    <th class="py-0 px-1">Local</th>
                                                    <!-- <th class="py-0 px-1">PedidosYa</th>
                                                    <th class="py-0 px-1">WhatsApp</th>
                                                    <th class="py-0 px-1">UberEats</th> -->
                                                    <th class="py-0 px-1"></th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(m, i) in productos" :key="i">
                                                        <td class="py-0 px-1">{{ i + 1 }}</td>
                                                        <td class="py-0 px-1">{{ m.name }}</td>
                                                        <td class="py-0 px-1">{{ m.venta }}</td>
                                                        <!-- <td class="py-0 px-1">{{ m.doble == 1 ? 'Si' : 'No' }}</td> -->
                                                        <td class="py-0 px-1">{{ m.disponible == 1 ? 'Si' : 'No' }}</td>
                                                        <td class="py-0 px-1">{{ m.disponible ? m.local == 1 ? 'Si' :'No' : 'No' }}</td>
                                                        <!-- <td class="py-0 px-1">{{ m.disponible ? m.pedidosYa == 1 ? 'Si':'No' : 'No' }}</td>
                                                        <td class="py-0 px-1">{{ m.disponible ? m.WhatsApp == 1 ? 'Si':'No' : 'No' }}</td>
                                                        <td class="py-0 px-1">{{ m.disponible ? m.UberEats == 1 ? 'Si':'No' : 'No' }}</td> -->
                                                        <td class="py-0 px-1">
                                                            <div class="btn-group">
                                                                <button class="btn btn-primary btn-sm py-1 px-2"
                                                                    title="Editar Valor"
                                                                    @click="editar_valor_producto7(m)">
                                                                    <i class="fas fa-edit"></i>
                                                                </button>
                                                                <a @click="eliminar7(m.id)"
                                                                    class="btn btn-danger btn-sm py-1 px-2">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Ventas" v-if="false">
                                <div class="row">
                                    <div class="col-md-12">
                                        <loading-message v-if="isLoading8" />
                                        <div class="row ">
                                            <div class="col-md-8">
                                                <h4 class="mb-2">Listado de Ingredientes</h4>
                                            </div>
                                            <div class="col-md-4 text-right">
                                                <!-- <b-button class="btn btn-darkpurple btn-md py-2 mr-2"
                                                    @click="ver_modal_producto('nuevo', '')">
                                                    <i class="fas fa-plus"></i> Agregar artículo/ingrediente
                                                </b-button>
                                                <b-button class="btn btn-teal btn-md py-2" v-b-modal="'csv'"
                                                    v-if="user.rol == 'Admin'">
                                                    <i class="fas fa-file-csv"></i> Desde CSV
                                                </b-button> -->
                                            </div>
                                            <b-modal id="csv" ref="csv" title="Cargar articulos/productos desde CSV"
                                                hide-footer>
                                                <div class="col-12">
                                                    <b-button @click="descargar_formato" :disabled="!buttonDisabled"
                                                        variant="teal" class="float-right mb-3">
                                                        <i class="fas fa-download"></i> Descargar Formato CSV
                                                    </b-button>
                                                    <loading-message v-if="isLoading8" />
                                                    <div>
                                                        <b-form-file v-model="fileproductos"
                                                            :state="Boolean(fileproductos)"
                                                            placeholder="Selecciona un archivo o arrástralo aquí..."
                                                            drop-placeholder="Suelta el archivo aquí..."
                                                            @change="onFileProductosChange"></b-form-file>
                                                        <p> </p>
                                                        <b-button @click="uploadCsvArticulos" :disabled="buttonDisabled"
                                                            variant="primary" class="float-right">Cargar
                                                            CSV</b-button>
                                                    </div>
                                                </div>
                                            </b-modal>
                                            <!--
                                            <div class="col-sm-12 col-md-6 mt-4">
                                                <div id="tickets-table_length" class="dataTables_length">
                                                    <label class="d-inline-flex align-items-center">
                                                        Mostrar&nbsp;
                                                        <b-form-select v-model="perPage" size="sm"
                                                            :options="pageOptions"></b-form-select>&nbsp;productos
                                                    </label>
                                                </div>
                                            </div>
                                            -->
                                            <!-- Search 
                                            <div class="col-sm-12 col-md-6 mt-4">
                                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                                    <label class="d-inline-flex align-items-center">
                                                        Buscar:
                                                        <b-form-input v-model="filter" type="search"
                                                            placeholder="Buscar..."
                                                            class="form-control form-control-sm ml-2"></b-form-input>
                                                    </label>
                                                </div>
                                            </div>
                                             End search -->
                                        </div>
                                        <!-- Table -->
                                        <div class="table-responsive mb-0">
                                            <b-table class="table-nowrap" :items="articulos_mes.filter(a=> a.def=='Ingredientes')" :fields="fields"
                                                responsive="sm" :per-page="perPage" :current-page="currentPage"
                                                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
                                                :filter-included-fields="filterOn" @filtered="onFiltered">
                                                <template v-slot:cell(index)="data">
                                                    {{ data.index + 1 }}
                                                </template>
                                                <template v-slot:cell(nombre)="data">
                                                    {{ data.item.name }}
                                                </template>
                                                <template v-slot:cell(cod)="data">
                                                    {{ data.item.barra }}
                                                </template>
                                                <template v-slot:cell(marca)="data">
                                                    {{ data.item.marca ? data.item.marca.name : '' }}
                                                </template>
                                                <template v-slot:cell(categoria)="data">
                                                    {{ data.item.categoria ? data.item.categoria.name : '' }}
                                                </template>
                                                <template v-slot:cell(tipo)="data">
                                                    {{ data.item.tipo ? data.item.tipo.name : '' }}
                                                </template>
                                                <template v-slot:cell(ubicacion)="data">
                                                    {{ data.item.ubicacion ? data.item.ubicacion.name : '' }}
                                                </template>
                                                <template v-slot:cell(stock_mes_anterior)="data">
                                                    {{ - data.item.stock_mes_anterior }}
                                                </template>
                                                <template v-slot:cell(stock_mes)="data">
                                                    {{ - data.item.stock_mes }}
                                                </template>
                                                <template v-slot:cell(acciones)="data">
                                                    <b-button size="sm" variant="primary"
                                                        @click="ver_modal_producto('editar', data.item)"><i
                                                            class="fas fa-edit"></i></b-button>
                                                    <b-button size="sm" variant="danger"
                                                        @click="eliminar8(data.item)"><i
                                                            class="fas fa-trash"></i></b-button>
                                                </template>
                                            </b-table>
                                        </div>
                                        <!--
                                        <div class="row">
                                            <div class="col">
                                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                                    <ul class="pagination pagination-rounded mb-0">
                                                         pagination
                                                        <b-pagination v-model="currentPage" :total-rows="rows"
                                                            :per-page="perPage"></b-pagination>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        -->
                                    </div>
                                    <b-modal id="modal_producto" ref="modal_producto" header-bg-variant="primary"
                                        title-class="text-white" ok-title="Guardar" cancel-title="Cancelar"
                                        @ok="producto_nuevo ? guardar_producto() : update_producto()">
                                        <template #modal-header="{ close }">
                                            <h5 class="text-white" v-if="producto_nuevo">Agregar artículo/ingrediente
                                            </h5>
                                            <h5 class="text-white" v-else>Editar artículo/ingrediente</h5>
                                            <div class="text-right">
                                                <b-button class="text-white text-right" size="sm" variant="none"
                                                    @click="close()">
                                                    <i class="bx bx-x font-size-16"></i>
                                                </b-button>
                                            </div>
                                        </template>
                                        <div class="row p-3">
                                            <div class="col-md-6">
                                                <b-form-group id="input-group-1" label="Nombre artículo/ingrediente"
                                                    label-for="input-1">
                                                    <b-form-input id="input-1" name="nombre" v-model="articulo.name"
                                                        type="text" placeholder="Ingresar Nombre"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-6">
                                                <b-form-group id="input-group-1" label="Valor" label-for="input-1">
                                                    <b-form-input id="input-1" name="venta" v-model="articulo.venta"
                                                        type="text" placeholder="Ingresar Valor"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-6">
                                                <b-form-group id="input-group-1" label="Stock minimo"
                                                    label-for="input-1">
                                                    <select class="custom-select" v-model="articulo.stock_minimo">
                                                        <option :value="1">1</option>
                                                        <option :value="2">2</option>
                                                        <option :value="3">3</option>
                                                        <option :value="4">4</option>
                                                        <option :value="5">5</option>
                                                        <option :value="10">10</option>
                                                        <option :value="20">20</option>
                                                        <option :value="30">30</option>
                                                        <option :value="40">40</option>
                                                        <option :value="50">50</option>
                                                        <option :value="100">100</option>
                                                    </select>
                                                </b-form-group>
                                            </div>
                                            <div :class="user.sucursal.categorizaciones.includes('SKU') ? 'col-md-6' : 'col-md-12'"
                                                v-if="user.sucursal.categorizaciones.includes('CODIGODEBARRA')">
                                                <b-form-group id="input-group-2" label="Codigo Barra"
                                                    label-for="input-2">
                                                    <b-form-input id="input-1" name="codigo" v-model="articulo.barra"
                                                        type="text" placeholder="Ingresar Codigo"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div :class="user.sucursal.categorizaciones.includes('CODIGODEBARRA') ? 'col-md-6' : 'col-md-12'"
                                                v-if="user.sucursal.categorizaciones.includes('SKU')">
                                                <b-form-group id="input-group-1" label="Codigo interno/Sku"
                                                    label-for="input-1">
                                                    <b-form-input id="input-1" name="sku" v-model="articulo.sku"
                                                        type="text"
                                                        placeholder="Ingresar Codigo interno / Sku"></b-form-input>
                                                </b-form-group>
                                            </div>
                                            <div :class="(tipos.length > 0 && user.sucursal.categorizaciones.includes('Clasificaciones')) && (ubicaciones.length > 0 && user.sucursal.categorizaciones.includes('Ubicaciones')) ? 'col-md-4' : 'col-md-6'"
                                                v-if="categorias.length > 0 && user.sucursal.categorizaciones.includes('Categorias')">
                                                <b-form-group id="input-group-1" label="Categoria" label-for="input-1">
                                                    <select class="custom-select" v-model="articulo.categoria_id">
                                                        <option value="">Selecciona una categoria</option>
                                                        <option v-for="(categoria, i) in categorias"
                                                            :label="categoria.name" :value="categoria.id" :key="i">
                                                        </option>
                                                    </select>
                                                </b-form-group>
                                            </div>
                                            <div :class="(categorias.length > 0 && user.sucursal.categorizaciones.includes('Categorias')) && (ubicaciones.length > 0 && user.sucursal.categorizaciones.includes('Ubicaciones')) ? 'col-md-4' : 'col-md-6'"
                                                v-if="tipos.length > 0 && user.sucursal.categorizaciones.includes('Clasificaciones')">
                                                <b-form-group id="input-group-1" label="Clasificacion"
                                                    label-for="input-1">
                                                    <select class="custom-select" v-model="articulo.tipo_id">
                                                        <option value="">Selecciona la Clasificacion</option>
                                                        <option v-for="(tipo, i) in tipos" :label="tipo.name"
                                                            :value="tipo.id" :key="i">
                                                        </option>
                                                    </select>
                                                </b-form-group>
                                            </div>
                                            <div :class="(categorias.length > 0 && user.sucursal.categorizaciones.includes('Categorias')) && (tipos.length > 0 && user.sucursal.categorizaciones.includes('Clasificaciones')) ? 'col-md-4' : 'col-md-6'"
                                                v-if="false && ubicaciones.length > 0 && user.sucursal.categorizaciones.includes('Ubicaciones')">
                                                <b-form-group id="input-group-1" label="Ubicacion" label-for="input-1">
                                                    <select class="custom-select" v-model="articulo.ubicacion_id">
                                                        <option value="">Selecciona una ubicacion</option>
                                                        <option v-for="(ubicacion, i) in ubicaciones"
                                                            :label="ubicacion.name" :value="ubicacion.id" :key="i">
                                                        </option>
                                                    </select>
                                                </b-form-group>
                                            </div>
                                            <div :class="marcas.length > 0 && user.sucursal.categorizaciones.includes('Marcas') ? 'col-md-6' : 'col-md-12'"
                                                v-if="false && marcas.length > 0 && user.sucursal.categorizaciones.includes('Marcas')">
                                                <b-form-group id="input-group-1" label="Marca" label-for="input-1">
                                                    <select class="custom-select" v-model="articulo.marca_id">
                                                        <option value="">Selecciona una marca</option>
                                                        <option v-for="(marca, i) in marcas" :label="marca.name"
                                                            :value="marca.id" :key="i">
                                                        </option>
                                                    </select>
                                                </b-form-group>
                                            </div>
                                            <div :class="medidas.length > 0 && user.sucursal.categorizaciones.includes('Medidas') ? 'col-md-6' : 'col-md-12'"
                                                v-if="false && medidas.length > 0 && user.sucursal.categorizaciones.includes('Medidas')">
                                                <b-form-group id="input-group-1" label="Medida" label-for="input-1">
                                                    <select class="custom-select" v-model="articulo.medida_id">
                                                        <option value="">Selecciona una medida</option>
                                                        <option v-for="(medida, i) in medidas" :label="medida.name"
                                                            :value="medida.id" :key="i">
                                                        </option>
                                                    </select>
                                                </b-form-group>
                                            </div>
                                            <div class="col-md-12"
                                                v-if="articulo.tipo_id != '' && articulo.tipo_id != 1">
                                                <b-form-checkbox v-model="articulo.local" :true-value="1"
                                                    :false-value="0" class="me-3">
                                                    Local
                                                </b-form-checkbox>
                                                <!-- <b-form-checkbox v-model="articulo.pedidosYa" :true-value="1"
                                                    :false-value="0">
                                                    PedidosYa
                                                </b-form-checkbox> -->
                                            </div>
                                        </div>
                                    </b-modal>
                                </div>
                            </b-tab>
                            <b-tab title="Categorias" v-if="user.sucursal.categorizaciones.includes('Categorias')">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="bg-soft-primary p-4">
                                            <label class="mb-3" for="title">
                                                {{ categoriaEditandoId ? 'Editar Categoría' : 'Agregar Categoría' }}
                                            </label>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Nombre">
                                                <b-form-input for="text" placeholder="Nombre"
                                                    v-model="datos1.name"></b-form-input>
                                            </b-form-group>
                                            <b-button block variant="primary"
                                                :disabled="!datos1.name || !String(datos1.name).trim()"
                                                @click="agregar1()">
                                                {{ categoriaEditandoId ? 'Guardar cambios' : 'Agregar' }}
                                            </b-button>
                                            <b-button v-if="categoriaEditandoId" block variant="secondary" class="mt-2"
                                                @click="cancelarEdicionCategoria()">Cancelar edición</b-button>

                                            <loading-message v-if="isLoading1" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-hover mb-0">
                                                <thead>
                                                    <th class="py-0 px-1">#</th>
                                                    <th class="py-0 px-1">NOMBRE</th>
                                                    <th class="py-0 px-1"></th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(m, i) in categorias" :key="i">
                                                        <td class="py-0 px-1">{{ i + 1 }}</td>
                                                        <td class="py-0 px-1">{{ m.name }}</td>
                                                        <td class="py-0 px-1">
                                                            <div class="btn-group">
                                                                <a @click="editar1(m)"
                                                                    class="btn btn-primary btn-sm py-1 px-2">
                                                                    <i class="fas fa-edit"></i>
                                                                </a>
                                                                <a @click="eliminar1(m.id)"
                                                                    class="btn btn-danger btn-sm py-1 px-2">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Canales" v-if="false && user.sucursal.categorizaciones.includes('Canales')">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="bg-soft-primary p-4">
                                            <label class="mb-3" for="title">Agregar Canal</label>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Nombre">
                                                <b-form-input for="text" placeholder="Nombre"
                                                    v-model="datos9.name"></b-form-input>
                                            </b-form-group>
                                            <b-button v-show="datos9.name !== ''" block variant="primary"
                                                @click="agregar9()">Agregar</b-button>
                                            <loading-message v-if="isLoading9" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-hover mb-0">
                                                <thead>
                                                    <th class="py-0 px-1">#</th>
                                                    <th class="py-0 px-1">NOMBRE</th>
                                                    <th class="py-0 px-1"></th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(m, i) in canales" :key="i">
                                                        <td class="py-0 px-1">{{ i + 1 }}</td>
                                                        <td class="py-0 px-1">{{ m.name }}</td>
                                                        <td class="py-0 px-1">
                                                            <div class="btn-group">
                                                                <a @click="eliminar9(m.id)"
                                                                    class="btn btn-danger btn-sm py-1 px-2">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Turnos" v-if="false && user.sucursal.categorizaciones.includes('Turnos')">
                                <div class="row"><b-modal id="editar_turno" ref="editar_turno" hide-footer>
                                        <template #modal-title>Editar turno {{ valor_editar.name }}</template>
                                        <div class="row justify-content-center">
                                            <div class="col-md-12 col-lg-12 col-xl-12">
                                                <!-- <img src="/images/Logo-Menu.png" alt class="img-fluid pb-3"/> -->
                                                <div class="card overflow-hidden">
                                                    <div class="card-body pt-5">
                                                        <b-form-group id="input-group-122" label="Horario de inicio"
                                                            label-for="input-122">
                                                            <b-form-select v-model="valor_editar.horario_ini"
                                                                :options="horariosi"
                                                                placeholder="Seleccione hora de inicio"></b-form-select>
                                                        </b-form-group>
                                                        <b-form-group id="input-group-122" label="Horario de termino"
                                                            label-for="input-122">
                                                            <b-form-select v-model="valor_editar.horario_fin"
                                                                :options="horariosf"
                                                                placeholder="Seleccione hora de termino"></b-form-select>
                                                        </b-form-group>
                                                        <button class="btn btn-success btn-sm py-2 px-4"
                                                            @click="guardar_turno()">
                                                            Guardar
                                                        </button>
                                                    </div>
                                                </div>
                                                <!-- end row -->
                                            </div>
                                            <!-- end col -->
                                        </div>
                                    </b-modal>
                                    <div class="col-md-6 mb-2">
                                        <div class="bg-soft-primary p-4">
                                            <label class="mb-3" for="title"><h3>Agregar Turno</h3></label>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Nombre:">
                                                <b-form-input for="text" placeholder="Nombre"
                                                    v-model="datos10.name"></b-form-input>
                                            </b-form-group>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Alias:">
                                                <b-form-input for="text" placeholder="Alias"
                                                    v-model="datos10.alias"></b-form-input>
                                            </b-form-group>
                                            <b-form-group label="Hora de inicio:" label-cols-sm="12" label-cols-lg="3">
                                                <b-form-select v-model="datos10.horario_ini" :options="horariosi"
                                                    placeholder="Seleccione hora de inicio"></b-form-select>
                                            </b-form-group>
                                            <!-- Campo de Hora de Fin -->
                                            <b-form-group label="Hora de fin:" label-cols-sm="12" label-cols-lg="3">
                                                <b-form-select v-model="datos10.horario_fin" :options="horariosf"
                                                    placeholder="Seleccione hora de fin"></b-form-select>
                                            </b-form-group>
                                            <b-button v-show="datos10.name !== ''" block variant="primary"
                                                @click="agregar10()">Agregar</b-button>
                                            <loading-message v-if="isLoading10" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-hover mb-0">
                                                <thead>
                                                    <th class="py-0 px-1">#</th>
                                                    <th class="py-0 px-1">NOMBRE</th>
                                                    <th class="py-0 px-1">ALIAS</th>
                                                    <th class="py-0 px-1">INICIO</th>
                                                    <th class="py-0 px-1">FIN</th>
                                                    <th class="py-0 px-1"></th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(m, i) in turnos" :key="i">
                                                        <td class="py-0 px-1">{{ i + 1 }}</td>
                                                        <td class="py-0 px-1">{{ m.name }}</td>
                                                        <td class="py-0 px-1">{{ m.alias }}</td>
                                                        <td class="py-0 px-1">{{ m.horario_ini }}</td>
                                                        <td class="py-0 px-1">{{ m.horario_fin }}</td>
                                                        <td class="py-0 px-1">
                                                            <div class="btn-group">
                                                                <!-- <button class="btn btn-primary btn-sm py-1 px-2"
                                                                    title="Editar" @click="editar_turno(m)">
                                                                    <i class="fas fa-edit"></i>
                                                                </button> -->
                                                                <a @click="eliminar10(m.id)"
                                                                    class="btn btn-danger btn-sm py-1 px-2">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Marcas" v-if="false && user.sucursal.categorizaciones.includes('Marcas')">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="bg-soft-primary p-4">
                                            <label class="mb-3" for="title">Agregar Marca</label>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Nombre">
                                                <b-form-input for="text" placeholder="Nombre"
                                                    v-model="datos2.name"></b-form-input>
                                            </b-form-group>
                                            <b-button v-show="datos2.name !== ''" block variant="primary"
                                                @click="agregar2()">Agregar</b-button>
                                            <loading-message v-if="isLoading2" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-hover mb-0">
                                                <thead>
                                                    <th class="py-0 px-1">#</th>
                                                    <th class="py-0 px-1">NOMBRE</th>
                                                    <th class="py-0 px-1"></th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(m, i) in marcas" :key="i">
                                                        <td class="py-0 px-1">{{ i + 1 }}</td>
                                                        <td class="py-0 px-1">{{ m.name }}</td>
                                                        <td class="py-0 px-1">
                                                            <div class="btn-group">
                                                                <a @click="eliminar2(m.id)"
                                                                    class="btn btn-danger btn-sm py-1 px-2">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Medidas" v-if="false && user.sucursal.categorizaciones.includes('Medidas')">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="bg-soft-primary p-4">
                                            <label class="mb-3" for="title">Agregar Medidas</label>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Nombre">
                                                <b-form-input for="text" placeholder="Nombre"
                                                    v-model="datos3.name"></b-form-input>
                                            </b-form-group>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Codigo">
                                                <b-form-input for="text" placeholder="Codigo"
                                                    v-model="datos3.codigo"></b-form-input>
                                            </b-form-group>
                                            <b-button v-show="datos3.name !== '' && datos3.codigo !== ''" block
                                                variant="primary" @click="agregar3()">Agregar</b-button>
                                            <loading-message v-if="isLoading3" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-hover mb-0">
                                                <thead>
                                                    <th class="py-0 px-1">#</th>
                                                    <th class="py-0 px-1">NOMBRE</th>
                                                    <th class="py-0 px-1">CODIGO</th>
                                                    <th class="py-0 px-1"></th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(m, i) in medidas" :key="i">
                                                        <td class="py-0 px-1">{{ i + 1 }}</td>
                                                        <td class="py-0 px-1">{{ m.name }}</td>
                                                        <td class="py-0 px-1">{{ m.codigo }}</td>
                                                        <td class="py-0 px-1">
                                                            <div class="btn-group">
                                                                <a @click="eliminar3(m.id)"
                                                                    class="btn btn-danger btn-sm py-1 px-2">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Ubicaciones" v-if="false && user.sucursal.categorizaciones.includes('Ubicaciones')">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="bg-soft-primary p-4">
                                            <label class="mb-3" for="title">Agregar Ubicaciones</label>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Nombre">
                                                <b-form-input for="text" placeholder="Nombre"
                                                    v-model="datos5.name"></b-form-input>
                                            </b-form-group>
                                            <b-button v-show="datos5.name !== ''" block variant="primary"
                                                @click="agregar5()">Agregar</b-button>
                                            <loading-message v-if="isLoading5" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-hover mb-0">
                                                <thead>
                                                    <th class="py-0 px-1">#</th>
                                                    <th class="py-0 px-1">NOMBRE</th>
                                                    <th class="py-0 px-1"></th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(m, i) in ubicaciones" :key="i">
                                                        <td class="py-0 px-1">{{ i + 1 }}</td>
                                                        <td class="py-0 px-1">{{ m.name }}</td>
                                                        <td class="py-0 px-1">
                                                            <div class="btn-group">
                                                                <a @click="eliminar5(m.id)"
                                                                    class="btn btn-danger btn-sm py-1 px-2">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                            <b-tab title="Clientes" v-if="false && user.sucursal.categorizaciones.includes('Clientes')">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="bg-soft-primary p-4">
                                            <label class="mb-3" for="title">Agregar Clientes</label>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Nombre">
                                                <b-form-input for="text" placeholder="Nombre"
                                                    v-model="datos6.name"></b-form-input>
                                            </b-form-group>
                                            <b-form-group label-cols-sm="12" label-cols-lg="3" label="Descripcion">
                                                <b-form-input for="text" placeholder="Descripcion"
                                                    v-model="datos6.descripcion"></b-form-input>
                                            </b-form-group>
                                            <b-button v-show="datos6.name !== ''" block variant="primary"
                                                @click="agregar6()">Agregar</b-button>
                                            <loading-message v-if="isLoading6" />
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="table-responsive">
                                            <table class="table table-hover mb-0">
                                                <thead>
                                                    <th class="py-0 px-1">#</th>
                                                    <th class="py-0 px-1">NOMBRE</th>
                                                    <th class="py-0 px-1">DESCRIPCION</th>
                                                    <th class="py-0 px-1"></th>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(m, i) in clientes" :key="i">
                                                        <td class="py-0 px-1">{{ i + 1 }}</td>
                                                        <td class="py-0 px-1">{{ m.name }}</td>
                                                        <td class="py-0 px-1">{{ m.descripcion }}</td>
                                                        <td class="py-0 px-1">
                                                            <div class="btn-group">
                                                                <a @click="eliminar6(m.id)"
                                                                    class="btn btn-danger btn-sm py-1 px-2">
                                                                    <i class="fas fa-trash"></i>
                                                                </a>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>



<style lang="scss" scoped></style>